import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-stats',
  templateUrl: './home-stats.component.html',
  styleUrls: ['./home-stats.component.scss']
})
export class HomeStatsComponent {
  @Input() achievements: any[] = [];
}